import styled from '@emotion/styled'
import { SPACING } from 'constants/spacing.constants'
import { WidgetComponentProps } from '../../wilsonChat.types'
import { hydrateRechartsSerializedJsxElement } from './dataChartWidget.utils'
import { useErrorBoundary, withErrorBoundary } from 'react-use-error-boundary'
import Typography from 'components/core/Typography'
import { useMemo } from 'react'
import { pxToRem } from 'utils/rem.utils'
import { RechartsSerializedJSXElement } from './dataChart.types'

const StyledDataChartWidget = styled.div`
    padding: ${SPACING.p2};
    gap: ${SPACING.p1};
    min-width: ${pxToRem(500)};
    height: ${pxToRem(500)};
    font-size: ${pxToRem(12)};
    font-family: Inter;
    font-weight: 500;
`

export type DataChartWidgetData = {
    dataChartId: string
    data: Record<string, unknown>[]
    chartConfig: RechartsSerializedJSXElement
}

export type DataChartWidgetProps = WidgetComponentProps<
    'DataChart',
    DataChartWidgetData
>

export const DataChartWidgetRenderer = ({
    widgetData,
}: DataChartWidgetProps) => {
    const element = useMemo(
        () =>
            hydrateRechartsSerializedJsxElement({
                jsonJsxElement: widgetData.chartConfig,
                data: widgetData.data,
            }),
        [widgetData]
    )

    return <StyledDataChartWidget>{element}</StyledDataChartWidget>
}

export const DataChartWidget = withErrorBoundary(
    (props: DataChartWidgetProps) => {
        const [error] = useErrorBoundary()
        if (error) {
            return (
                <StyledDataChartWidget>
                    <Typography variant="body2" color="secondary">
                        Encountered an error while rendering the chart.
                    </Typography>
                </StyledDataChartWidget>
            )
        }

        return <DataChartWidgetRenderer {...props} />
    }
)
